export function verticalSlider() {
    const $slider = $(".vertical .slider-section");
    const $window = $(window);
    if ($slider.find(".slider-section-item").length <= 1) {
        $(".slider-section-holder").addClass("only-one-slide");
    }
    $window.on("scroll", function () {
        const $items = $(".add-slider-nav .item");
        const $windowHeight = $window.outerHeight();
        $items.each(function () {
            const $itemTop = $(this).offset().top;
            const $itemBottom = $itemTop + $(this).outerHeight();
            const $windowTop = $window.scrollTop();

            if ($windowTop + $windowHeight > $itemTop && $windowTop + $windowHeight < $itemBottom) {
                $(this).addClass("active").siblings().removeClass("active");
                const index = $(this).index();
                $slider.slick("slickGoTo", index);
            }
        });
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/verticalSlider.js